import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { clone, includes, isFunction, sortBy } from 'lodash';
import { CovanceGridColumn } from './covance-grid-column';
import { comparators } from '../core/comparators';

export class GroupingResult<T> {
    public columns: CovanceGridColumn[];
    public data: T;

    constructor(columns: CovanceGridColumn[], data: T) {
        this.columns = clone(columns);
        this.data = data;
    }
}

@Injectable()
export class CovanceAgGridHelper {

    public groupData<T>(groupBy: string, data: T[], columns: CovanceGridColumn[], hiddenColumns: string[] = null, sortInGroup: (a: T, b: T) => number = null) {
        const result = new GroupingResult(columns, data);

        result.columns.forEach(col => {
            if (col.headerName === groupBy) {
                col.rowGroupIndex = 0;
                col.hide = true;

                if (result.data) {
                    result.data = result.data = this.sortData(col, result.data as T[], sortInGroup);
                }
            } else {
                col.rowGroupIndex = null;
                if (!includes(hiddenColumns, col.headerName)) {
                    col.hide = false;
                }
            }
        });

        return result;
    }

    public sortData<T>(sortColumn: CovanceGridColumn, data: T[], postSort: (a: T, b: T) => number = null) {
        if (!data) {
            return data;
        }

        const valueGetter = isFunction(sortColumn.valueGetter) ?
            (value: any) => (sortColumn.valueGetter as (params: any) => any) ({ data: value }) :
            (value: any) => value[sortColumn.field];

        const comparator = sortColumn.comparator ?
            (valueA: any, valueB: any) => sortColumn.comparator(valueA, valueB) :
            (valueA: any, valueB: any) => comparators.stringComparator(valueA, valueB);

        const sortArgs: [(a: T, b: T) => number] = [
            (a: T, b: T) => {
                const valueA = a ? valueGetter(a) : null;
                const valueB = b ? valueGetter(b) : null;
                return comparator(valueA, valueB);
            }
        ];

        if (postSort) {
            sortArgs.push(postSort);
        }

        const result = sortBy(data, sortArgs);

        return result;
    }
}